/**
 * actionTrail模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const actionTrail = {
  // 显示列表
  listActionTrailEvent(params) {
    return $http.post(`${global.API_URL}/sme/actionTrail/listActionTrailEvent`,params);
  }
}

export default actionTrail;



// WEBPACK FOOTER //
// ./src/api/actionTrail.js